module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABXklEQVR4AWJwL/BBwavW7bZZtRbQOFkbxBJFYXheAy/BmyClBPqAGnCISSkAy1ZmR5EruLu7OyRogsNhfpzx3fH/Hv+uaEprbCel8bukJi6ccyKts1rb7st2r/9+6Owc/5/SRMYxopDzRtV5iccBjJMaX3Qb9A1M0M7uIfX2j//5rmqy+o8Dv8gZU9Lj4xPh9/DwSKohfuuvGYMVw/a9Zr90rY4++v0z2nr+6E6flonon4KGBdW8u3dEr6+vtL1z4KurpihS0G2viBK6qKdvnLgcJs2Qvg7ShihXMCo/EQ38+q1v7Pg6cBrfoGDOfuLk9FIMB6weDib8xJX17SgHKKFUUTVR5yceHp1FOXjRNFagAE8Q5l7Au0cIZaw5xuMTC97oGmv9Bgl4RiDsbt6xZXXn/dkLwBOExTFWre5Cz2bCCTxBWIDxC9L+iuzrACfwBGGABHPGqNBtNAy6+3wDIbG6EFxxQ0sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon.png
// module id = k3R8
// module chunks = 1